export const MIN_ADULT_AGE = 18
export const MAX_ADULT_AGE = 59
export const MIN_ELDERLY_AGE = 60
export const MAX_ELDERLY_AGE = 140
export const MIN_KID_AGE = 3
export const MAX_KID_AGE = 12
export const MIN_ADOLESCENT_AGE = 13
export const MAX_ADOLESCENT_AGE = 17

export type AgeCategories = 'KID' | 'ADOLESCENT' | 'ADULT' | 'ELDERLY'
